import {Injectable} from '@angular/core';
import {StripePaymentState} from '../../store/payment-state';
import {Observable, of} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {first, map} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {GlobalMessageType, TranslationService} from '@spartacus/core';
import {PaymentErrorConfig, stripeErrorConfig} from '../../error-handling/payment-error-configs.model';
import {StripeErrorCode} from '@app/payment/services/error-handling/stripe-error-code.enum';
import {IDcpGlobalErrorMessage} from '@app/core/models/interfaces/error';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class StripePaymentErrorService {
  constructor(
    private translationService: TranslationService,
  ) {
  }

  getMessageForStripe(state: StripePaymentState): Observable<IDcpGlobalErrorMessage> {
    const httpResponse: HttpErrorResponse = state?.error as HttpErrorResponse;
    const error = httpResponse?.error?.errors[0];
    const errorCode: StripeErrorCode = StripeErrorCode[error?.errorCode] || StripeErrorCode.DEFAULT;
    const errorConfig: PaymentErrorConfig = stripeErrorConfig[errorCode];
    if (errorConfig.staticMessageCode) {
      return this.translationService.translate(errorConfig.staticMessageCode).pipe(
        first(),
        untilDestroyed(this),
        map(staticMessage => {
          const msg = this.buildMessage(errorCode, errorConfig, staticMessage);
          return this.buildDisposableMessage(msg, GlobalMessageType.MSG_TYPE_ERROR, errorConfig.showSupportLink);
        }));
    } else {
      const backendErrorMessage = error?.message;
      const msg = this.buildMessage(errorCode, errorConfig, backendErrorMessage);
      return of(this.buildDisposableMessage(msg, GlobalMessageType.MSG_TYPE_ERROR, errorConfig.showSupportLink));
    }
  }

  private buildMessage(errorCode: string, errorConfig: PaymentErrorConfig, message: string): string {
    return `${errorConfig.showErrorCode ? `${errorCode}: ` : ''}${message}${errorConfig.showSupportLink ? ' If the issue persists, please' : ''}`;
  }

  private buildDisposableMessage(message: string, type: GlobalMessageType, showSupportLink: boolean): IDcpGlobalErrorMessage {
    return {
      message,
      type,
      showSupportLink,
    };
  }
}
